<i18n>
{
  "en": {
    "title": "Energy University Strategy & Sustainability 2017-2018",
    "description": "Energy University brings energy management training to the world with more than 200 free, vendor-neutral e-learning courses in 13 languages. Learn about Energy University’s global impact in 2017.",
    "sustainable": {
      "section": "Sustainable Solutions",
      "title": "Energy University",
      "university": {
        "energyUniversity": {
          "title": "Energy University Highlights 2017-2018",
          "para": "An online training program that offers more than 200 free, vendor-neutral e-learning courses in 13 languages. Its purpose is to improve careers and help companies improve efficiency and sustainability."
        },
        "universitySnapshot": {
          "title": "Energy University in 2017",
          "one": {
            "stat": "73,077",
            "unit": "total registrations"
          },
          "two": {
            "stat": "675,000",
            "unit": "registered users",
            "para": "since inception"
          },
          "three": {
            "stat": "115,242",
            "unit": "courses taken"
          },
          "four": {
            "stat": "1,000,000",
            "para": "courses completed since inception"
          },
          "five": {
            "stat": "28",
            "para": "Professional Energy Manager certifications awarded"
          }
        },
        "countriesRegistrations": {
          "title": "Top countries for registrations",
          "one": {
            "title": "1",
            "para": "1. United States",
            "unit": "9,648"
          },
          "two": {
            "title": "2",
            "para": "2. Brazil",
            "unit": "9,252"
          },
          "three": {
            "title": "3",
            "para": "3. Egypt",
            "unit": "5,017"
          },
          "four": {
            "title": "4",
            "para": "4. Mexico",
            "unit": "3,888"
          },
          "five": {
            "title": "5",
            "para": "5. India",
            "unit": "3,808"
          }
        },
        "countriesCompletions": {
          "title": "Top countries for completions",
          "one": {
            "title": "1",
            "para": "1. United States",
            "unit": "33,431"
          },
          "two": {
            "title": "2",
            "para": "2. Egypt",
            "unit": "26,351"
          },
          "three": {
            "title": "3",
            "para": "3. India",
            "unit": "4,429"
          },
          "four": {
            "title": "4",
            "para": "4. Mexico",
            "unit": "3,169"
          },
          "five": {
            "title": "5",
            "para": "5. Brazil",
            "unit": "3,138"
          }
        },
        "countriesCertifications": {
          "title": "Top countries for Professional Energy Manager certifications",
          "one": {
            "title": "1",
            "para": "1. United States",
            "unit": "9"
          },
          "two": {
            "title": "2",
            "para": "2. Saudi Arabia",
            "unit": "2"
          },
          "three": {
            "title": "3",
            "para": "3. United Kingdom",
            "unit": "1"
          },
          "four": {
            "title": "4",
            "para": "4. Australia",
            "unit": "1"
          },
          "five": {
            "title": "5",
            "para": "5. Lebanon",
            "unit": "1"
          }
        },
        "cta": {
          "button": "Learn more",
          "copy": "Find out how Energy University<sup>&trade;</sup> is bringing energy education to the world."
        }
      }
    }
  },
  "fr": {
    "title": "Energy University Strategy & Sustainability 2017-2018",
    "description": "Energy University brings energy management training to the world with more than 200 free, vendor-neutral e-learning courses in 13 languages. Learn about Energy University’s global impact in 2017.",
    "sustainable": {
      "section": "Nos solutions durables",
      "title": "Energy University",
      "university": {
        "energyUniversity": {
          "title": "Energy University Highlights 2017-2018",
          "para": "L'Energy University™ est un programme de formation en ligne qui donne accès gratuitement à plus de 200 formations en 13 langues. Son objectif est d'aider les utilisateurs à atteindre leurs objectifs de carrière et les entreprises à améliorer leur efficacité et leur démarche de développement durable."
        },
        "universitySnapshot": {
          "title": "Energy University en 2017",
          "one": {
            "stat": "73 077",
            "unit": "inscriptions"
          },
          "two": {
            "stat": "675 000",
            "unit": "utilisateurs inscrits",
            "para": "depuis le lancement"
          },
          "three": {
            "stat": "115 242",
            "unit": "formations reçues"
          },
          "four": {
            "stat": "1 000 000",
            "para": "cours dispensés depuis le lancement"
          },
          "five": {
            "stat": "28",
            "para": "certifications en gestion de l’énergie (PEM) décernées"
          }
        },
        "countriesRegistrations": {
          "title": "Principaux pays en nombre d’inscriptions :",
          "one": {
            "title": "1",
            "para": "1. États-Unis",
            "unit": "9 648"
          },
          "two": {
            "title": "2",
            "para": "2. Brésil",
            "unit": "9 252"
          },
          "three": {
            "title": "3",
            "para": "3. Égypte",
            "unit": "5 017"
          },
          "four": {
            "title": "4",
            "para": "4. Mexique",
            "unit": "3 888"
          },
          "five": {
            "title": "5",
            "para": "5. Inde",
            "unit": "3 808"
          }
        },
        "countriesCompletions": {
          "title": "Principaux pays en nombre de formations reçues :",
          "one": {
            "title": "1",
            "para": "1. États-Unis",
            "unit": "33 431"
          },
          "two": {
            "title": "2",
            "para": "2. Egypt",
            "unit": "26 351"
          },
          "three": {
            "title": "3",
            "para": "3. India",
            "unit": "4 429"
          },
          "four": {
            "title": "4",
            "para": "4. Mexique",
            "unit": "3 169"
          },
          "five": {
            "title": "5",
            "para": "5. Brasil",
            "unit": "3 138"
          }
        },
        "countriesCertifications": {
          "title": "Principaux pays en nombre de certifications en gestion de l’énergie (PEM) :",
          "one": {
            "title": "1",
            "para": "1. États-Unis",
            "unit": "9"
          },
          "two": {
            "title": "2",
            "para": "2. Arabie saoudite",
            "unit": "2"
          },
          "three": {
            "title": "3",
            "para": "3. Royaume-Uni",
            "unit": "1"
          },
          "four": {
            "title": "4",
            "para": "4. Australie",
            "unit": "1"
          },
          "five": {
            "title": "5",
            "para": "5. Liban",
            "unit": "1"
          }
        },
        "cta": {
          "button": "Pour en savoir plus",
          "copy": "Découvrir l'éducation à l'énergie partout dans le monde grâce à Energy University"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/sustainable/sustainable-solutions-energy-university-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/sustainable/sustainable-solutions-energy-university-hero.jpg')" chapter="02" :section="$t('sustainable.section')" :title="$t('sustainable.title')"/>

   <section class="m-b-120 m-t-120">
      <TxtMedia class="m-b-80">
        <div slot="main-content">
          <p v-html="$t('sustainable.university.energyUniversity.para')"/>
          <p class="t-grey" v-html="$t('sustainable.university.cta.copy')"></p>
          <CTA href="http://www.MyEnergyUniversity.com" :buttonText="$t('sustainable.university.cta.button')" target="_blank" />
        </div>
        <img slot="sidebar" src="../../assets/img/sustainable/sustainable-solutions-energy-university.png" />
      </TxtMedia>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Snapshot class="m-b-0">
        <div slot="above">
          <h2 id="energyuniversitynumbers" v-html="$t('sustainable.university.universitySnapshot.title')"/>
        </div>
        <SnapshotCard :double="true" :bgc="$root.sassVars.cGreenLight" class="t-white">
          <h4 v-html="$t('sustainable.university.universitySnapshot.one.stat')"/>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.one.unit')"/>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.university.universitySnapshot.two.stat')"/>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.two.unit')"/>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.two.para')"/>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.university.universitySnapshot.three.stat')"/>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.three.unit')"/>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('sustainable.university.universitySnapshot.four.stat')"/>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.four.para')"/>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/sustainable/GettyImages-595172997.jpg')">
          <h4 class="" v-html="$t('sustainable.university.universitySnapshot.five.stat')"/>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.universitySnapshot.five.para')"/>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <Snapshot class="m-b-50">
        <div slot="above"><h2 id="eutopcountriesregistration" v-html="$t('sustainable.university.countriesRegistrations.title')"/></div>
        <SnapshotCard :double="true">
          <UnitedStates class="m-b-20"></UnitedStates>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesRegistrations.one.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesRegistrations.one.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <Brazil class="m-b-20"></Brazil>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesRegistrations.two.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesRegistrations.two.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <Egypt class="m-b-20"></Egypt>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesRegistrations.three.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesRegistrations.three.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <Mexico class="m-b-20"></Mexico>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesRegistrations.four.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesRegistrations.four.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <India class="m-b-20" />
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesRegistrations.five.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesRegistrations.five.para')"/>
        </SnapshotCard>
      </Snapshot>

      <Snapshot class="m-b-50">
        <div slot="above"><h2 id="eutopcountriescompletion" v-html="$t('sustainable.university.countriesCompletions.title')"/></div>
        <SnapshotCard :double="true">
          <UnitedStates class="m-b-20"></UnitedStates>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCompletions.one.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCompletions.one.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <Egypt class="m-b-20"></Egypt>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCompletions.two.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCompletions.two.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <India class="m-b-20"></India>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCompletions.three.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCompletions.three.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <Mexico class="m-b-20"></Mexico>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCompletions.four.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCompletions.four.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <Brazil class="m-b-20" />
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCompletions.five.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCompletions.five.para')"/>
        </SnapshotCard>
      </Snapshot>

      <Snapshot class="m-b-32">
        <div slot="above"><h2 id="eutopcountriescertification" v-html="$t('sustainable.university.countriesCertifications.title')"/></div>
        <SnapshotCard :double="true">
          <UnitedStates class="m-b-20"></UnitedStates>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCertifications.one.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCertifications.one.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <SaudiArabia class="m-b-20"></SaudiArabia>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCertifications.two.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCertifications.two.para')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <UnitedKingdom class="m-b-20"></UnitedKingdom>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCertifications.three.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCertifications.three.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <Australia class="m-b-20"></Australia>
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCertifications.four.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCertifications.four.para')"/>
        </SnapshotCard>
        <SnapshotCard>
          <Lebanon class="m-b-20" />
          <h4 class="t-green-light" v-html="$t('sustainable.university.countriesCertifications.five.unit')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.university.countriesCertifications.five.para')"/>
        </SnapshotCard>
      </Snapshot>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="SustainableSolutions_SupplyChain"
        prevRoute="SustainableSolutions_Research" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'

import UnitedStates from '@/assets/img/sustainable/united-states.svg'
import Brazil from '@/assets/img/sustainable/brazil.svg'
import Egypt from '@/assets/img/sustainable/egypt.svg'
import Mexico from '@/assets/img/sustainable/mexico.svg'
import India from '@/assets/img/sustainable/india.svg'
import SaudiArabia from '@/assets/img/sustainable/saudi-arabia.svg'
import UnitedKingdom from '@/assets/img/sustainable/united-kingdom.svg'
import Australia from '@/assets/img/sustainable/australia.svg'
import Lebanon from '@/assets/img/sustainable/lebanon.svg'

export default {
  name: 'Introduction_Welcome',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    TxtMedia,
    Txt,
    Snapshot,
    SnapshotCard,
    UnitedStates,
    Brazil,
    Egypt,
    Mexico,
    India,
    SaudiArabia,
    UnitedKingdom,
    Australia,
    Lebanon
  }
}
</script>

<style lang="scss" scoped>
  svg {
    height: 80px;
    max-width: 80px;
    fill: #626469;
    path {
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sustainable-solutions/energy-university.vue